enum Position {
   Top = 'Top',
   Right = 'Right',
   Bottom = 'Bottom',
   Left = 'Left',
}

enum InputType {
   Button = 'button',
   Checkbox = 'checkbox',
   Color = 'color',
   Date = 'date',
   DatetimeLocal = 'datetime-local',
   Email = 'email',
   File = 'file',
   Hidden = 'hidden',
   Image = 'image',
   Month = 'month',
   Number = 'number',
   Password = 'password',
   Radio = 'radio',
   Range = 'range',
   Reset = 'reset',
   Search = 'search',
   Submit = 'submit',
   Tel = 'tel',
   Text = 'text',
   Time = 'time',
   Url = 'url',
   Week = 'week',
}

enum InputGroupTextType {
   Prepend = 'Prepend',
   Append = 'Append',
}

enum InputValidation {
   Valid = 'valid',
   Invalid = 'invalid',
}

export { Position, InputType, InputGroupTextType, InputValidation };
